import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as React from 'react';
import { UpwardTransition } from 'src/utils';
import { IMessage } from '../actions/message';
import i18n from '../resources/i18n';

/**
 * メッセージダイアログ
 */
export default class MessageDialog extends React.Component<IMyProps> {
	public render() {
		const {
			open,
			showCancelButton,
			onClickCancel,
			onClickOk,
			onClose,
			title = i18n.t('MessageDialog_0001'),
			contents,
			messageNs = 'message',
			style,
			className,
		} = this.props;
		const messages: string[] = contents.map(
			(item: IMessage): string => {
				const { content, replacements } = item;
				let message = i18n.t(content, { ns: messageNs });
				if (replacements) {
					replacements.map((replacement: string, index: number) => {
						message = message.replace(
							'{' + index + '}',
							replacement
						);
					});
				}
				return message;
			}
		);

		return (
			<Dialog
				className={className}
				open={open}
				TransitionComponent={UpwardTransition}
				keepMounted={true}
				onClose={onClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				style={{ ...style, zIndex: 3000 }}
			>
				<DialogTitle id="alert-dialog-slide-title">
					{i18n.t(title, { ns: messageNs })}
				</DialogTitle>
				<DialogContent>
					<DialogContentText
						id="alert-dialog-slide-description"
						dangerouslySetInnerHTML={{
							__html: messages.join('<br/>'),
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClickOk} color="primary">
						{i18n.t('MessageDialog_0002')}
					</Button>
					{showCancelButton && (
						<Button
							onClick={onClickCancel ? onClickCancel : onClose}
							color="primary"
						>
							{i18n.t('MessageDialog_0003')}
						</Button>
					)}
				</DialogActions>
			</Dialog>
		);
	}
}

interface IMyProps {
	open: boolean;
	onClickOk: () => void;
	onClickCancel?: () => void;
	onClose: () => void;
	title?: string;
	contents: IMessage[];
	showCancelButton: boolean;
	messageNs?: string;
	style?: React.CSSProperties;
	className?: string;
}



// WEBPACK FOOTER //
// ./src/components/MessageDialog.tsx